import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

window.axios = require('axios')
window.axios.defaults.baseURL = 'https://api.otimizze.me/v0/'

import Home from './views/Home';
import Obrigado from './views/Obrigado';

import './assets/css/fonts.css'
import './assets/css/fixes.css'

const router = new VueRouter({
  mode: 'history',
  base: '/luzesombra',
  //fallback: true,
  routes: [
    { path: '/', component: Home },
    { path: '/obrigado', component: Obrigado },
    // { path: '/', redirect: '/home' }
  ]
});

Vue.config.productionTip = false

new Vue({
  vuetify,
  axios,
  router,
  render: h => h(App)
}).$mount('#app')
